import {isAnyOf as _isAnyOf} from 'util/redux/matcher'
import {PayloadActionCreator as _PayloadActionCreator, createAction as _createAction, PayloadAction as _PayloadAction} from 'util/redux/createAction'
import {ActionReducerMapBuilder as _ActionReducerMapBuilder, createReducer as _createReducer} from 'util/redux/createReducer'

//matcher
export const isAnyOf = _isAnyOf

//action
export type PayloadAction<P = void, T extends string = string> = _PayloadAction<P, T>
export type PayloadActionCreator<P, T extends string = string> = _PayloadActionCreator<P, T>
export const createAction = _createAction

//reducer
export type ActionReducerMapBuilder<T> = _ActionReducerMapBuilder<T>
export const createReducer = _createReducer
